import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';

const CONSENT_KEY = 'giztoo_cookie_consent';

export type ConsentStatus = 'accepted' | 'rejected' | null;

export function getConsentStatus(): ConsentStatus {
  if (typeof window === 'undefined') return null;
  const v = localStorage.getItem(CONSENT_KEY);
  if (v === 'accepted' || v === 'rejected') return v;
  return null;
}

export const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsentStatus()) setVisible(true);
  }, []);

  const handleChoice = (choice: 'accepted' | 'rejected') => {
    localStorage.setItem(CONSENT_KEY, choice);
    setVisible(false);
    const decision = choice === 'accepted' ? 'granted' : 'denied';
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      if (decision === 'denied') window.gtag('set', 'user_data', null);
      window.gtag('consent', 'update', {
        ad_storage: decision,
        ad_user_data: decision,
        ad_personalization: decision,
      });
    }
    if (choice === 'accepted') {
      window.dispatchEvent(new Event('cookie-consent-accepted'));
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-card border-t border-border shadow-lg p-4 md:p-6">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center gap-4">
        <p className="text-sm text-muted-foreground flex-1">
          This website uses cookies for analytics and to improve your experience. Learn more in our{' '}
          <a href="/privacy" className="underline text-primary hover:text-primary/80">
            Privacy Policy
          </a>.
        </p>
        <div className="flex gap-3 shrink-0">
          <Button variant="outline" size="sm" onClick={() => handleChoice('rejected')}>
            Decline
          </Button>
          <Button size="sm" onClick={() => handleChoice('accepted')}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};